import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MeetingRegistrationResponse } from '../types/MeetingRegistrationResponse';
import { PublicOnlineMeetingDTO } from 'src/app/features/registration/types/PublicOnlineMeetingDTO';
import { RegisterForMeetingRequestDTO } from 'src/app/features/registration/types/RegisterForMeetingRequestDTO';
import { PublicMeetingDTO } from '../types/PublicMeetingDTO';

const DEFAULT_OPTIONS = {
  headers: new HttpHeaders({
    accept: '*/*',
  }),
} satisfies any;

@Injectable({
  providedIn: 'root',
})
export class PublicMeetingService {
  private _options = DEFAULT_OPTIONS;

  private _isPostInProgress$ = new BehaviorSubject(false);
  /**
   * Global observable for tracking whether the client
   * is awaiting a fetch call for 'postComment'.
   */
  public isPostInProgress$ = this._isPostInProgress$.asObservable();

  private _isRevalidating$ = new BehaviorSubject(false);
  /**
   * Global observable for tracking whether the client
   * is awaiting a fetch call for 'getCommentByGuid'.
   */
  public isRevalidating$ = this._isRevalidating$.asObservable();

  constructor(private http: HttpClient) {}

  getInPersonMeetingByGuid(guid: string): Observable<PublicMeetingDTO> {
    return this.http
      .get<PublicMeetingDTO>(`${environment.ApiUrl}/Meeting/GetMeeting/${guid}`, this._options)
      .pipe(
        tap(() => this._isRevalidating$.next(true)),
        tap({
          error: (error) => {
            console.error('Error get comment by guid:', error);
          },
          complete: () => {
            this._isRevalidating$.next(false);
          },
        })
      );
  }

  getOnlineMeetingByGuid(guid: string): Observable<PublicOnlineMeetingDTO> {
    return this.http
      .get<PublicOnlineMeetingDTO>(
        `${environment.ApiUrl}/Meeting/GetOnlineMeeting/${guid}`,
        this._options
      )
      .pipe(
        tap(() => this._isRevalidating$.next(true)),
        tap({
          error: (error) => {
            console.error('Error get comment by guid:', error);
          },
          complete: () => {
            this._isRevalidating$.next(false);
          },
        })
      );
  }

  registerForMeeting(body: RegisterForMeetingRequestDTO): Observable<MeetingRegistrationResponse> {
    return this.http
      .post<MeetingRegistrationResponse>(
        `${environment.ApiUrl}/Meeting/RegisterForMeeting`,
        body,
        this._options
      )
      .pipe(
        tap(() => this._isPostInProgress$.next(true)),
        tap({
          error: (error) => {
            console.error('Error post comment:', error);
          },
          complete: () => {
            this._isPostInProgress$.next(false);
          },
        })
      );
  }
}
